import { TFunction } from "i18next";

import { CardGuide } from "@components/common";

export const getDMSteps = (t: TFunction): CardGuide["steps"] => {
  return [
    {
      title: `${t("doubleMateriality.step", "STEP")} 1`,
      description: t("doubleMateriality.steps.stakeholders", "Stakeholders"),
    },
    {
      title: `${t("doubleMateriality.step", "STEP")} 2`,
      description: t(
        "doubleMateriality.steps.qualitativeAssessment",
        "Qualitative materiality assessment",
      ),
    },
    {
      title: `${t("doubleMateriality.step", "STEP")} 3`,
      description: t(
        "doubleMateriality.steps.questionCreationStudio",
        "Question creation studio",
      ),
    },
    {
      title: `${t("doubleMateriality.step", "STEP")} 4`,
      description: t(
        "doubleMateriality.steps.questionAssignment",
        "Question assignment",
      ),
    },
    {
      title: `${t("doubleMateriality.step", "STEP")} 5`,
      description: t("doubleMateriality.steps.results", "Results"),
    },
  ];
};
